import React from 'react';
import {
  VictoryLine,
  VictoryChart,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryLabel,
  VictoryArea
} from 'victory';
import '../Analytics/Charts.css';

const LineChart = ({ data, xKey, yKey, color = '#60A5FA', height = 300 }) => {
  if (!data || data.length === 0) {
    return <div className="empty-chart">No data available</div>;
  }

  // Format data for Victory
  const formattedData = data.map(item => ({
    x: item[xKey],
    y: item[yKey]
  }));

  // Custom theme matching your dark mode design
  const customTheme = {
    chart: {
      padding: { top: 40, bottom: 50, left: 60, right: 40 }
    },
    axis: {
      style: {
        axis: {
          stroke: '#64748b'
        },
        grid: {
          stroke: 'rgba(100, 116, 139, 0.1)'
        },
        tickLabels: {
          fill: '#94a3b8',
          fontSize: 10
        }
      }
    }
  };

  return (
    <div style={{ height: `${height}px`, width: '100%' }}>
      <VictoryChart
        theme={customTheme}
        height={height}
        padding={{ top: 20, bottom: 40, left: 60, right: 30 }}
        containerComponent={
          <VictoryVoronoiContainer
            labels={({ datum }) => 
              `${yKey}: ${datum.y}\n${xKey}: ${datum.x}`
            }
            labelComponent={
              <VictoryTooltip
                style={{ fontSize: 10, fill: '#fff' }}
                flyoutStyle={{
                  stroke: 'none',
                  fill: 'rgba(0, 0, 0, 0.8)'
                }}
              />
            }
          />
        }
        animate={{
          duration: 2000,
          onLoad: { duration: 1000 }
        }}
      >
        <defs>
          <linearGradient id={`gradient-${color.replace('#', '')}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={color} stopOpacity={0.2} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>

        <VictoryAxis
          tickFormat={(t) => t}
          style={{
            tickLabels: { fill: '#94a3b8', fontSize: 10 }
          }}
        />
        
        <VictoryAxis
          dependentAxis
          style={{
            tickLabels: { fill: '#94a3b8', fontSize: 10 }
          }}
        />

        <VictoryArea
          data={formattedData}
          style={{
            data: {
              fill: `url(#gradient-${color.replace('#', '')})`,
              stroke: 'none'
            }
          }}
          interpolation="monotoneX"
        />

        <VictoryLine
          data={formattedData}
          style={{
            data: {
              stroke: color,
              strokeWidth: 2
            }
          }}
          interpolation="monotoneX"
        />
      </VictoryChart>
    </div>
  );
};

export default LineChart; 